<h2 mat-dialog-title class="title">{{title}}</h2>
<mat-dialog-content>
  {{message}}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close cdkFocusInitial>Aceptar</button>
</mat-dialog-actions>
